<script setup lang="ts"></script>

<template>
  <header class="site-header">
    <div class="header-inner">
      <RouterLink class="brand" to="/" aria-label="Castle Country Digital — home">
        <span class="brand-mark" aria-hidden="true">
          <span class="brand-mark-letters">CCD</span>
        </span>
        <span class="brand-words">
          <span class="brand-name">Castle Country Digital</span>
          <span class="brand-meta">EMERY · CARBON · UTAH</span>
        </span>
      </RouterLink>
      <nav class="site-nav" aria-label="Primary">
        <RouterLink to="/security">
          <span class="nav-num">01</span>
          <span class="nav-label">Security</span>
        </RouterLink>
        <RouterLink to="/seo">
          <span class="nav-num">02</span>
          <span class="nav-label">SEO</span>
        </RouterLink>
      </nav>
    </div>
    <div class="header-rule" aria-hidden="true"></div>
  </header>
</template>

<style scoped>
.site-header {
  position: relative;
  background: linear-gradient(180deg, rgba(247, 244, 238, 0.92) 0%, rgba(247, 244, 238, 0.6) 100%);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

.header-inner {
  max-width: var(--max-w);
  margin: 0 auto;
  padding: 1.1rem 1.5rem 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1.5rem;
}

.header-rule {
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent 0%,
    var(--border) 12%,
    var(--border-bright) 50%,
    var(--border) 88%,
    transparent 100%
  );
}

.brand {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  color: var(--text);
  text-decoration: none;
}
.brand:hover {
  text-decoration: none;
}

.brand-mark {
  width: 38px;
  height: 38px;
  display: grid;
  place-items: center;
  border: 1px solid var(--border-bright);
  border-radius: var(--radius-sm);
  background: var(--surface);
  position: relative;
  overflow: hidden;
  transition:
    border-color 0.25s ease,
    background 0.25s ease;
}
.brand-mark::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, transparent 50%, var(--accent-tint) 100%);
}
.brand:hover .brand-mark {
  border-color: var(--accent);
  background: var(--surface-2);
}

.brand-mark-letters {
  font-family: var(--font-mono);
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  color: var(--accent-bright);
  position: relative;
  z-index: 1;
}

.brand-words {
  display: flex;
  flex-direction: column;
  line-height: 1;
  gap: 0.3rem;
}

.brand-name {
  font-family: var(--font-display);
  font-size: 1.15rem;
  font-weight: 500;
  letter-spacing: -0.01em;
  font-variation-settings: 'opsz' 36;
}

.brand-meta {
  font-family: var(--font-mono);
  font-size: 0.62rem;
  font-weight: 500;
  letter-spacing: 0.22em;
  color: var(--text-faint);
}

.site-nav {
  display: flex;
  gap: 0.25rem;
}

.site-nav a {
  display: inline-flex;
  align-items: baseline;
  gap: 0.45rem;
  padding: 0.55rem 0.85rem 0.5rem;
  border: 1px solid transparent;
  border-radius: var(--radius-sm);
  color: var(--text);
  text-decoration: none;
  transition:
    border-color 0.2s ease,
    background 0.2s ease,
    color 0.2s ease;
}

.site-nav a:hover {
  border-color: var(--border-bright);
  background: var(--surface-2);
  text-decoration: none;
}

.site-nav a.router-link-active {
  border-color: var(--border-bright);
  background: var(--surface);
  color: var(--accent-bright);
}

.nav-num {
  font-family: var(--font-mono);
  font-size: 0.65rem;
  letter-spacing: 0.15em;
  color: var(--text-faint);
}
.site-nav a:hover .nav-num,
.site-nav a.router-link-active .nav-num {
  color: var(--accent);
}

.nav-label {
  font-family: var(--font-display);
  font-size: 0.95rem;
  font-weight: 500;
  letter-spacing: 0.005em;
  font-variation-settings: 'opsz' 24;
}

@media (max-width: 560px) {
  .brand-words {
    gap: 0.25rem;
  }
  /* Keep the name on one line — wrapping turned the header into a four-line
     block on a 390px phone. The kicker is decorative and duplicates the
     footer, so it gives up its space rather than pushing the nav off-screen. */
  .brand-name {
    font-size: 0.95rem;
  }
  .brand-meta {
    display: none;
  }
  .site-nav a {
    padding: 0.45rem 0.6rem;
  }
  .nav-num {
    display: none;
  }
}
</style>
